export default {
  install: function (Vue) {
    Vue.mixin({
      methods: {
        getBild(bildId) {
          if (!bildId) return null;
          if (bildId.startsWith("http")) {
            let parts = bildId.split("/");
            let lastPart = parts[parts.length - 1];
            return `${process.env.VUE_APP_API_URL}pic/?name=${lastPart.split('_')[0]}.png`
          } else {
            return `${process.env.VUE_APP_API_URL}pic/?name=${bildId}`
          }
        },
      }
    })
  }
}
